import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPushSubscriptionState, getPushSubscriptions } from './selectors';
import { togglePushSubscription, updatePushSubscriptions, displayPushNotificationsModal } from './actions';
import { PushSubscriptionState } from './types';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { CompliantLocalStorageKeys } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/constants';
import { useBooleanLocalStorageValue } from '@wix/da-react-context/pkg/compliantLocalStorage/hooks';
export function usePushSubscription() {
    const state = useSelector(getPushSubscriptionState);
    const [isSubscribedLocally, setSubscribedLocally] = useBooleanLocalStorageValue(CompliantLocalStorageKeys.PWA_NOTIFICATIONS);
    // set initial value if unset
    if (state === PushSubscriptionState.SUBSCRIBED && !isSubscribedLocally) {
        setSubscribedLocally(true);
    }
    const dispatch = useDispatch();
    const toggle = useCallback(()=>{
        dispatch(togglePushSubscription());
        setSubscribedLocally(!isSubscribedLocally);
    }, [
        dispatch,
        setSubscribedLocally,
        isSubscribedLocally
    ]);
    return {
        state,
        isBlocked: typeof window !== 'undefined' && window.Notification && window.Notification.permission === 'denied',
        isSubscribed: state === PushSubscriptionState.SUBSCRIBED || isSubscribedLocally,
        canToggle: [
            PushSubscriptionState.SUBSCRIBED,
            PushSubscriptionState.READY_TO_SUBSCRIBE
        ].includes(state),
        toggle,
        manage: useAction(displayPushNotificationsModal)
    };
}
// get a PushSubscriptions map to see which notifications the user subscribed to
export function usePushSubscriptions() {
    const dispatch = useDispatch();
    const subscriptions = useSelector(getPushSubscriptions);
    const setSubscriptions = useCallback((updatedSubscriptions)=>{
        dispatch(updatePushSubscriptions(updatedSubscriptions));
    }, [
        dispatch
    ]);
    return [
        subscriptions,
        setSubscriptions
    ];
}

//# sourceMappingURL=hooks.js.map